import { gql } from '@apollo/client';
import { SERVICE_PROVIDER } from '../fragments';

export const ALL_FUNDER_SERVICE_PROVIDERS = gql`
  query AllFunderServiceProviders($input: FilterArgs) {
    serviceProviders: funderServiceProviders(input: $input) {
      ...serviceProvider
      interventions {
        id
        name
      }
      users {
        id
      }
      address
      contactNumber
    }
  }
  ${SERVICE_PROVIDER}
`;
